import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Badge, List, Popover, Tooltip } from '@material-ui/core';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';

import {
  getCloudSync,
  getCloudSyncTotalPercentage,
  getRequestsToSync,
} from 'reducers/connectivity/cloudSync';
import { useNotificationsCount } from 'containers/Header';

import styles from './CloudSync.module.scss';
import { CloudStatus } from './types';
import PendingRequests from './PendingRequests';
import CloudSync from './CloudSync';

const HeaderCloudSync = () => {
  const cloudSync: CloudStatus[] = useSelector(getCloudSync);
  const requestsToSync = useSelector(getRequestsToSync);

  const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);

  const [percentage, setPercentage] = useState(
    getCloudSyncTotalPercentage(cloudSync),
  );
  useEffect(() => {
    const i = setInterval(
      () => setPercentage(getCloudSyncTotalPercentage(cloudSync)),
      500,
    );
    return () => clearInterval(i);
  }, [cloudSync]);

  const offline = percentage <= 0;
  const partial = percentage > 0 && percentage < 1;
  const online = percentage >= 1;

  useNotificationsCount(partial || requestsToSync > 0 ? 1 : 0);

  const { t } = useTranslation('header');
  return (
    <div data-testid="header-cloud-sync">
      <Badge
        data-testid={`cloudsync-notification-${
          partial ? 'sync-percentage' : 'request-count'
        }`}
        badgeContent={requestsToSync}
        style={{
          fontSize: 10,
          zIndex: partial ? 50000 : undefined,
        }}
      >
        <Tooltip
          title={
            (offline && t('sync.title', { context: 'fail' })) ||
            (partial && t('sync.title', { context: 'pending' })) ||
            (online && t('sync.title', { context: 'done' })) ||
            ''
          }
        >
          <CloudQueueIcon
            className={classNames('icon-button hoverable', styles.syncIcon, {
              [styles.offline]: offline,
              [styles.updating]: partial,
              [styles.online]: online,
            })}
            style={{
              fontSize: '24px',
              color: partial || requestsToSync > 0 ? 'orange' : 'white',
              margin: 0,
              cursor: 'pointer',
            }}
            onClick={e => setAnchorEl(e.currentTarget)}
          />
        </Tooltip>
      </Badge>
      <Popover
        className="erply-header__dropdown erply-header__dropdown--sync"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        data-testid="cloudsync-menu"
        style={{ maxHeight: 'calc(100vh - 20px)', overflowY: 'auto' }}
      >
        <List>
          {cloudSync.map(({ name, todo, done, progress, time, syncing }) => {
            if (name === 'pendingRequests') {
              return (
                <PendingRequests
                  key={name}
                  todo={todo}
                  syncing={syncing}
                  time={time}
                  progress={progress}
                  done={done}
                />
              );
            }
            return (
              <CloudSync
                key={name}
                name={name}
                done={done}
                progress={progress}
                todo={todo}
                time={time}
                syncing={syncing}
              />
            );
          })}
        </List>
      </Popover>
    </div>
  );
};

export default HeaderCloudSync;
